import React from 'react'
import type { Location } from 'react-router-dom'

import BrowseLibraries from './BrowseLibraries'

const BrowseLibrariesContainer = ({
  location,
  children,
}: {
  location: Location
  children: React.ReactNode
}): React.ReactNode => {
  return (
    <BrowseLibraries location={location} showInBrowseLibrariesPage>
      {children}
    </BrowseLibraries>
  )
}

export default BrowseLibrariesContainer
